import type { ReactNode } from 'react';

import { useAccessDeniedStore } from '../../hooks';
import { RequestAccessPage } from '../RequestAccessPage';

export const AccessDeniedFirewall = ({ children }: { children: ReactNode }) => {
    const { isDenied } = useAccessDeniedStore();

    if (isDenied) {
        return <RequestAccessPage />;
    }

    return children;
};
